// Artifact ids follow the house convention (`pgid-org-artifacts-<uuid>`),
// and the same rule chat applies to conversation ids applies to URLs
// (#11499, #11819): a link carries only the bare identifier, and the routing
// boundary converts back. Prefixed links already in the wild (delivery
// emails, copied before this change) keep resolving.
export const ARTIFACT_ID_PREFIX = "pgid-org-artifacts-";

export const toArtifactSlug = (id: string): string =>
  id.startsWith(ARTIFACT_ID_PREFIX) ? id.slice(ARTIFACT_ID_PREFIX.length) : id;

export const fromArtifactSlug = (slug: string): string =>
  slug.startsWith(ARTIFACT_ID_PREFIX) ? slug : `${ARTIFACT_ID_PREFIX}${slug}`;

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Whether a `/artifacts/:id` path segment names an artifact (bare uuid or
 *  prefixed id) rather than a report-editor workspace (a Mongo ObjectId). */
export const isArtifactSlug = (segment: string): boolean =>
  segment.startsWith(ARTIFACT_ID_PREFIX) || UUID_RE.test(segment);

/** The shareable in-app link for an artifact. */
export const artifactLink = (id: string): string =>
  `${window.location.origin}/artifacts/${toArtifactSlug(id)}`;
